import React from 'react';

const Gracias = () => {
  return (
    <div style={{ padding: '100px 20px', textAlign: 'center', color: '#FFA860', backgroundColor: '#0a1728', minHeight: '100vh' }}>
      <h1>¡Gracias por contactarnos!</h1>
      <p>Hemos recibido tu mensaje. Te responderemos lo antes posible.</p>
    </div>
  );
};

export default Gracias;
